const category = 'ClientInformation';

const cards = [
    {
        name: "Basic Info",
        id: "basicInfo",
        fields: [
            [{ id: "TemplateName", field: "templateName", category: "Info", type: "custom" }],
            [{ id: "ClientId", field: "clientId", category: "Info", type: "custom" }],
            [{ id: "ConfigLabel", field: "configLabel", category: "Info", type: "custom" }],
            [{ id: "LegalName" }],
            [{ id: "CommonName" }],
            [{ id: "PhoneNumber" }],
            [{ id: "FaxNumber" }],
            [{ id: "EmailAddress" }],
            [{ id: "URL" }],
            [{ id: "FinancialInstitutionType" }],
            [{ id: "Calendar" }],
        ],
    },
    {
        name: "Address",
        id: "address",
        personalDetail: true,
        fields: [
            [{ id: "Attention" }],
            [{ id: "AddressLine1" }],
            [{ id: "AddressLine2" }],
            [{ id: "AddressLine3" }],
            [
                { id: "City" },
                { id: "State" },
                { id: "Zip" },
            ],
            [{ id: "Country" }],
        ],
    },
    {
        name: "Financial Details",
        id: "financialDetails",
        fields: [
            [
                {
                    id: "RoutingNumber",
                    category: "AppSpecificBackOffice",
                },
            ],
            [
                {
                    id: "DefaultCurrency",
                },
            ],
        ],
    },
    {
        name: "Logo",
        id: "logo",
        fields: [
            [{ field: "logo", type: "custom", questionName: 'Logo', answerFields: ['FileName', 'FileSource', 'FileType'] }],
        ],
    },
];

export { cards, category };